import React, { FunctionComponent } from 'react';
import { Radio } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { IPagination } from '../pagination.model';
import styles from './page-size-controls-component.module.scss';

type PageSizeControlsProps = {
  labels?: ILabel[] | null;
  pagination: IPagination;
  onChange: (pagination: IPagination) => void;
};

export const PageSizeControls: FunctionComponent<PageSizeControlsProps> = (props: PageSizeControlsProps) => {
  if (props.pagination.totalProducts > 20)
    return (
      <div className={styles['page-size-controls']}>
        <label>{getLabel(props.labels, 'show')}</label>
        <Radio
          spacing={0.8}
          name='page-size'
          defaultSelection={props.pagination.size}
          list={[
            { key: 20, elt: 20 },
            { key: 40, elt: 40 },
            { key: 60, elt: 60 },
          ]}
          selectCallback={(key) => {
            let pagination = props.pagination;
            pagination.size = key as number;
            props.onChange(pagination);
          }}></Radio>
      </div>
    );
  return null;
};
